



















import Vue, { PropType } from 'vue';
import DropdownIndicator from '../../dropdowns/basics/DropdownIndicator/DropdownIndicator.vue';
import MultiSelectDropdown from '../../dropdowns/basics/MultiSelectDropdown/MultiSelectDropdown.vue';

const ICON_ACTIVE = 'arrow-up-bold';
const ICON_INACTIVE = 'arrow-down';

interface MultiSelectDropDownInterface extends Vue {
  selectAll(): void;
  clear(): void;
  toggleCheckbox(option: string): void;
}

export default Vue.extend({
  name: 'FilterMultiSelectDropdown',
  components: {
    MultiSelectDropdown,
    DropdownIndicator,
  },
  methods: {
    clear() {
      (this.$refs.multiSelectDropdown as MultiSelectDropDownInterface).clear();
    },
    removeItem(value: string) {
      (this.$refs.multiSelectDropdown as MultiSelectDropDownInterface).toggleCheckbox(value);
    },
  },
  props: {
    value: { // selected Items
      type: Array as PropType<string[]>,
      default: () => [],
    },
    label: String,
  },
  data() {
    return {
      activeIcon: ICON_ACTIVE,
      inactiveIcon: ICON_INACTIVE,
    };
  },
});
